<template>
  <ul class="page-info-list" style="position: relative;">
    <li class="page-info-item">
      <label class="page-info-tit">企业编码:</label>
      <span class="page-info-val">{{data.companyId}}</span>
    </li>
    <li class="page-info-item">
      <label class="page-info-tit">企业名称:</label>
      <span class="page-info-val">{{data.companyName}}</span>
    </li>
    <li class="page-info-item">
      <label class="page-info-tit">企业域:</label>
      <span class="page-info-val">{{data.companyDomain}}</span>
    </li>
    <li class="page-info-item">
      <label class="page-info-tit">账号:</label>
      <span class="page-info-val">{{data.sellerName}}</span>
    </li>
    <li class="page-info-item switch">
      <label class="page-info-tit">开启/锁定:</label>
      <span class="page-info-val">
        <i-switch  size="large" v-model="data.isLock"  :disabled="disabled || computedDisabled">
          <span slot="open">开启</span>
          <span slot="close">禁用</span>
        </i-switch>
        <span class="tip">
          用户连续登录3次失败账号将被锁定1小时。手动开启时，请将开关置成“开”的状态
        </span>
      </span>
    </li>
    <li class="page-info-item">
      <button class="ivu-btn ivu-btn-primary" @click.prevent="submit"> {{this.editFlag ? '确认提交' : '返回列表'}}</button>
    </li>
    <Spin fix v-if="spinFlag">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="10"></circle>
        </svg>
      </div>
    </Spin>
  </ul>
</template>

<script>
import { getSubAccountDetail, resetSubAccount } from '@/api/userManager.js'
import { msg } from '@/utils/index.js'
export default {
  name: 'detailInfo',
  data() {
    return {
      disabled: false,
      switch: true,
      editFlag: false, // true 代表编辑 false 代表查看
      data: {
        companyId: '',
        companyName: '',
        companyDomain: '',
        sellerName: '', // 账号
        isLock: ''
      },
      companyId: '',
      sellerId: '',
      corpTypeKey: '', // 1 工业 2 服务
      spinFlag: false
    }
  },
  computed: {
    computedDisabled() {
      return this.data.isLock === true // eslint-disable-line
    }
  },
  created() {
    const pageObj = { title: '', type: 'small', url: '' }
    if (this.$route.name.indexOf('Edit') !== -1) {
      this.disabled = false
      this.editFlag = true
      pageObj.title = '编辑'
    } else {
      this.disabled = true
      this.editFlag = false
      pageObj.title = '查看'
    }
    // this.$route.name.indexOf('Industry') !== -1 ? pageObj.url = 'detailListIndustry' : pageObj.url = 'detailListServer'
    // 故意将url写为空
    this.$store.dispatch('setPage', pageObj)
    this.corpTypeKey = this.$route.name.indexOf('Industry') !== -1 ? 1 : 2
    this.companyId = this.$route.query.id
    this.sellerId = this.$route.query.sellerId
    this.getData()
  },
  methods: {
    getData() {
      this.spinFlag = true
      getSubAccountDetail({
        company_id: this.companyId,
        corp_type_key: this.corpTypeKey,
        seller_id: this.sellerId
      }).then(res => {
        this.spinFlag = false
        const { code, result } = res
        if (code === 0) {
          this.data.companyId = result.company_id
          this.data.companyName = result.company_name
          this.data.companyDomain = result.company_domain
          this.data.sellerName = result.seller_name
          this.data.isLock = result.is_lock === 1 ? true : false // eslint-disable-line
          this.sellerId = result.seller_id
        } else {
          this.data = {}
        }
      })
    },
    submit() {
      if (this.editFlag) {
        resetSubAccount({
          company_id: this.companyId,
          corp_type_key: this.corpTypeKey,
          un_lock: this.data.isLock ? 1 : '',
          seller_id: this.sellerId
        }).then(res => {
          const { code } = res
          if (code === 0) {
            this.$router.go(-1)
          } else {
            msg.call(this, '提交失败！')
          }
        })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
